import { Link } from "react-router-dom";
import { IFullPlanDetail, IFullPlanDetailPPO } from "../../../interfaces/api";
import CompareStickMobile from "./CompareStickMobile.component";
import AccessDemand from "../AccessDemand.component";

const AllPlansHeaderMobile = ({
  plans,
  activePlan,
  setActivePlan,
}: {
  plans: IFullPlanDetail[] | IFullPlanDetailPPO[];
  activePlan: number;
  setActivePlan: (acitveplan: number) => void;
}) => {
  const hcode = plans[activePlan].PlanDetails[0].company[0].healthPlan[0].hCode;
  const pbpid =
    plans[activePlan].PlanDetails[0].company[0].healthPlan[0].pbp[0].id;
  return (
    <div className="grid-x margin-0 show-for-small-only">
      <h3
        className="cell blue-stroke text-center"
        style={{
          fontWeight: 600,
          fontSize: "39px",
          paddingBottom: "24px",
        }}
      >
        Comparing {plans.length} plans
      </h3>
      <div style={{ paddingBottom: 24, width: "100%" }}>
        <AccessDemand />
      </div>

      {plans.length === 3 ? (
        <>
          <div
            className="grid-x"
            style={{
              borderBottom: "1px solid #1B54C2",
              width: "100%",
            }}
          >
            <div className="cell small-4" onClick={() => setActivePlan(0)}>
              <CompareStickMobile
                data={plans[0]}
                activePlan={activePlan}
                planNumber={0}
              />
            </div>
            <div className="cell small-4" onClick={() => setActivePlan(1)}>
              <CompareStickMobile
                data={plans[1]}
                activePlan={activePlan}
                planNumber={1}
              />
            </div>
            <div className="cell small-4" onClick={() => setActivePlan(2)}>
              <CompareStickMobile
                data={plans[2]}
                activePlan={activePlan}
                planNumber={2}
              />
            </div>
          </div>
          <div className="grid-y" style={{ width: "100%" }}>
            <p style={{ display: "flex", justifyContent: "center" }}>
              <Link
                to={{
                  pathname: "/plan-details",
                  search: `?hcode=${hcode}&pbpid=${pbpid}`,
                }}
                className="color-primary text-underline"
                style={{
                  fontSize: "25px",
                  padding: "24px 0px",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
              >
                View Details
              </Link>
            </p>
            <button
              type="button"
              className="button"
              style={{
                flex: 1,
                minHeight: "55px",
                fontWeight: 500,
                width: "100%",
              }}
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.preventDefault();
                // NOT WORKING
              }}
            >
              Enroll
            </button>
          </div>
        </>
      ) : (
        <>
          <div
            className="grid-x"
            style={{
              borderBottom: "1px solid #1B54C2",
              width: "100%",
            }}
          >
            <div className="cell small-6" onClick={() => setActivePlan(0)}>
              <CompareStickMobile
                data={plans[0]}
                activePlan={activePlan}
                planNumber={0}
              />
            </div>
            <div className="cell small-6" onClick={() => setActivePlan(1)}>
              <CompareStickMobile
                data={plans[1]}
                activePlan={activePlan}
                planNumber={1}
              />
            </div>
          </div>
          <div className="grid-y" style={{ width: "100%" }}>
            <p style={{ display: "flex", justifyContent: "center" }}>
              <Link
                to={{
                  pathname: "/plan-details",
                  search: `?hcode=${hcode}&pbpid=${pbpid}`,
                }}
                className="color-primary text-underline"
                style={{
                  fontSize: "25px",
                  padding: "24px 0px",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
              >
                View Details
              </Link>
            </p>
            <button
              type="button"
              className="button"
              style={{
                flex: 1,
                minHeight: "55px",
                fontWeight: 500,
                width: "100%",
              }}
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.preventDefault();
                // NOT WORKING
              }}
            >
              Enroll
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default AllPlansHeaderMobile;
